import classNames from 'classnames';
import { BaseTextFieldProps, InputField } from './InputField';

export const TextareaField = ({ maxLength, textareaRef, ...props }: BaseTextFieldProps) => {
    return (
        <InputField {...props} renderElement={(formik, field, meta) => (
            <div className="data-item-col">
                <textarea
                    ref={textareaRef}
                    rows={3}
                    className={classNames('form-control', { 'is-invalid': meta.touched && meta.error && formik.submitCount })}
                    {...field}
                    disabled={props.disabled}
                    maxLength={maxLength}
                    value={field.value || ''}
                />
                {meta.touched && meta.error && <div className="form-error">{meta.error}</div>}
            </div>
        )} />
    );
}
